/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHeaderStates } from '../../Providers/HeaderStates';
import { useStartupState } from '../../Providers/StartupState';
import { Loading } from '../../components/Loading';
import { baseUrlImg, handleGetData } from '../../Api';
import { Capa } from '../../components/Capa';
import * as S from './style';

export const CopasulCulture = () => {                                                                                                                        
  const [data, setData] = useState(null);
  const { setTitle, setBgHeader } = useHeaderStates();
  const { token, setError, loading, setLoading } = useStartupState();

  useEffect(() => {
    setError(null);
    setLoading(true);
    if (token) {
      handleGetData(token, 'api/content/copasul/cultura/')
        .then((response) => {
          setData(response?.data?.items[0]?.data);
          if (response?.status !== 200) {
            throw new Error(response.message);
          }
        })
        .catch((e) => {
          setData(null);
          console.log(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token]);

  useEffect(() => {
    setTitle(null);
    setBgHeader(null);
  }, [setTitle, setBgHeader]);

  if (loading) {
    return <Loading />;
  } else {
    return (
      <>
        <Capa imagem={data?.imagemHeader?.iv?.[0]} titulo={data?.titulo?.iv} />
        <S.Container>
          <S.ImgLogo
            src={`${baseUrlImg}${data?.imagemTopo?.iv[0]}`}
            alt="logo de 45 anos copasul"
          />
          <S.ImgBox>
            {data?.imagens?.iv[0]?.imagem.map((item) => (
              <img src={`${baseUrlImg}${item}`} key={item} alt="cards" />
            ))}
          </S.ImgBox>
        </S.Container>
      </>
    );
  }
};
